import React, { useState } from 'react';

import '../Tables.css';
import TableCoursesRow from './TableCoursesRow';

// const defaultData = [
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
//     {
//         name: 'Русский язык',
//         progress: '12/20',
//         average: '95%',
//         group: '95%',
//     },
// ]
// const defaultMetrics = [
//     {
//         name: 'title',
//         orderType: 'asc'
//     },
//     {
//         name: 'avg',
//         orderType: 'asc'
//     },
 
// ]

const TableCourses = ({ data, sortTable }) => {
    // const [sortingData, setSortingData] = useState(defaultMetrics)
// console.log(sortingData)
    return (
        <div className='tableCourses__container'>
            {/* <div className='tableCourses__top'>
                <div className={`tableCourses__names tableTests__result`} onClick={() => {sortTable(sortingData[0].name, sortingData[0].orderType); sortingData[0] = {...sortingData[0], orderType: sortingData[0].orderType === 'asc'? 'desc' : 'asc'}   }} >
                Курсы
                <div className={`sortable ${sortingData[0].orderType === 'asc'? 'rotated': ''}`}></div>
               </div>
                <div className='tableCourses__results'>
                    <div >Пройдено тестов</div>
                    <div  className={`tableTests__result`} onClick={() => {sortTable(sortingData[1].name, sortingData[1].orderType); sortingData[1] = {...sortingData[1], orderType: sortingData[1].orderType === 'asc'? 'desc' : 'asc'}   }} >
                        Средний результат
                    <div className={`sortable ${sortingData[1].orderType === 'asc'? 'rotated': ''}`}></div>
                    </div>
                    <div >Результат группы</div>

                </div>
            </div> */}
            <div className='tableCourses__main'>
                {data.map((i, index) => (
                    <TableCoursesRow data={i} key={index} />
                ))}
            </div>
        </div>
    )
}
export default TableCourses
